import { useState, useCallback, useEffect } from "react";
import { TreeSelect } from "antd";
import { administrative as administrativeService } from "@/services";

function AdministrativeTreeSelect({ value, onChange, token }) {
  const [treeData, setTreeData] = useState([]);
  useEffect(() => {
    administrativeService.tree({}, token).then((res) => {
      const items = res.map((item) => ({
        id: item.id,
        pId: "86",
        value: item.id,
        title: item.name,
      }));
      setTreeData(items);
    });
  }, [setTreeData, token]);
  const loadDataHandler = useCallback(
    (node) => {
      return administrativeService
        .tree({ parent: node.id }, token)
        .then((res) => {
          const items = res.map((item) => {
            return {
              id: item.id,
              pId: node.id,
              value: item.id,
              title: item.name,
            };
          });
          setTreeData((treeData) => treeData.concat(items));
        });
    },
    [setTreeData, token]
  );
  return (
    <TreeSelect
      treeDataSimpleMode
      style={{ width: 200 }}
      value={value}
      dropdownStyle={{ maxHeight: 600, overflow: "auto" }}
      placeholder="请选择"
      onChange={(value) => {
        onChange(value);
      }}
      loadData={loadDataHandler}
      treeData={treeData}
    />
  );
}

export default AdministrativeTreeSelect;
